import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { MyHomeTrapContainer } from 'shared/containers/valuationTraps';
import { selectIsAgent } from 'shared/selectors';
import { selectIsMyHomeObjectsExists, selectIsMyHomeTrapBannerActive } from 'shared/selectors/valuationTraps';
import { selectOfferValuationData } from 'shared/store/offerValuation';

export const SuburbanValuationTrapLoader: React.FC = () => {
  const isAgent = useSelector(selectIsAgent);
  const isExperimentActive = useSelector(selectIsMyHomeTrapBannerActive);
  const isMyHomeObjectsExists = useSelector(selectIsMyHomeObjectsExists);
  const offerValuationData = useSelector(selectOfferValuationData);

  const isMyHomeTrapVisible = offerValuationData?.priceInfo && isExperimentActive && !isMyHomeObjectsExists && !isAgent;

  if (!isMyHomeTrapVisible) {
    return null;
  }

  return (
    <CardSectionNew hideForPrint>
      <MyHomeTrapContainer />
    </CardSectionNew>
  );
};
